import type { PictureProps } from './PictureProps.d';
import React, { type JSX } from 'react';
import cx from 'clsx';


export function Picture({
	alt,
	caption,
	className,
	imgProps = {},
	sources = [],
	src,
	...rest
}: PictureProps): JSX.Element {
	const p = (
		<picture className={caption ? undefined : cx(className)} {...rest}>
			{
				sources.map(({ media, srcSet }, i) => <source
					key={`${i}`}
					media={media}
					srcSet={srcSet}
				/>)
			}
			<img
				alt={alt}
				src={src}
				{...imgProps}
			/>
		</picture>
	);
	if (caption) {
		return (
			<figure className={cx(className)}>
				{p}
				<figcaption>{caption}</figcaption>
			</figure>
		);
	}
	return p;
}
